import {Component, OnDestroy, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '../../_models/user';
import {UserService} from '../../_services/user.service';
import {PageTitleService} from '../../_services/page-title.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AppConstants } from '../../_constants/constants';

@Component({
    selector: 'app-my-account',
    templateUrl: './my-account.component.html',
    styleUrls: ['./my-account.component.css'],
    standalone: false
})
export class MyAccountComponent implements OnInit, OnDestroy {
    title = 'Dashboard';
    titleKey = "sidebar.dashboard"
    loading = true;
    isAdmin = false;
    isLoggedIn = false;
    user: User;

    private subscriptions: Subscription[] = [];

    constructor(public titleService: Title,
                private pageTitleService: PageTitleService,
                private userService: UserService, private router: Router,
                private translateService: TranslateService,
                private route: ActivatedRoute,
                private toastr: ToastrService) {
        this.isLoggedIn = this.userService.isLoggedIn();
        this.user = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
        if (this.user) {
            this.isAdmin = this.userService.isAdmin();
            if (!this.isAdmin) {
                this.user = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
                this.isAdmin = this.userService.isAdmin();
                this.pageTitleService.setPageTitle(this.title);
                titleService.setTitle(this.title);

                const subs = this.translateService.get(this.titleKey).subscribe(value => {
                    this.titleService.setTitle(value);
                });

                this.subscriptions.push(subs);
            }
        } else {
            this.userService.logout();
        }
    }
    ngOnInit() {
        if (this.isAdmin) {
            this.router.navigateByUrl('admin/dashboard');
        }

        // Check if user was redirected due to pending seller approval
        this.route.queryParams.subscribe(params => {
            if (params['warning'] === 'seller_pending_approval') {
                const currentUserJson = localStorage.getItem(AppConstants.CURRENT_USER_KEY);
                const currentUser = currentUserJson ? JSON.parse(currentUserJson) : null;

                // Only show warning if user is actually a seller and NOT verified
                const isActuallyPending = currentUser &&
                    currentUser.role &&
                    currentUser.role.toLowerCase() === 'seller' &&
                    currentUser.seller &&
                    currentUser.seller.status !== 'VERIFIED';

                if (isActuallyPending) {
                    const subs = this.translateService.get('common.seller_pending_approval').subscribe(message => {
                        this.toastr.warning(message);
                    });
                    this.subscriptions.push(subs);
                }

                // Clean the URL param regardless so it doesn't persist on refresh
                this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: { warning: null },
                    queryParamsHandling: 'merge'
                });
            }
        });

        this.loading = false;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
